import React, { useState } from 'react';
import { suggestEmailCorrection } from '../../lib/emailValidation';

function AuthForm({
  fields,
  onSubmit,
  submitLabel,
  loadingLabel = 'Please wait…',
  loading = false,
  error,
  status,
  children,
}) {
  const [showPassword, setShowPassword] = useState({});
  const [emailSuggestion, setEmailSuggestion] = useState(null);

  const handleEmailChange = (field, value, onChange) => {
    onChange(value);
    if (field.type === 'email') {
      setEmailSuggestion(suggestEmailCorrection(value));
    }
  };

  const applySuggestion = (field) => {
    if (emailSuggestion && field.onChange) {
      field.onChange(emailSuggestion);
      setEmailSuggestion(null);
    }
  };

  return (
    <form
      className="auth-form"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(e);
      }}
      noValidate
    >
      {fields.map((field) => (
        <div className="auth-form__field" key={field.id}>
          <label className="auth-form__label" htmlFor={field.id}>
            {field.label}
          </label>
          <div className="auth-form__input-wrap">
            <input
              id={field.id}
              name={field.name}
              type={
                field.type === 'password'
                  ? showPassword[field.id]
                    ? 'text'
                    : 'password'
                  : field.type
              }
              className="auth-form__input"
              value={field.value}
              onChange={(e) => handleEmailChange(field, e.target.value, field.onChange)}
              placeholder={field.placeholder}
              autoComplete={field.autoComplete}
              required={field.required !== false}
              aria-invalid={field.invalid ? 'true' : undefined}
              aria-describedby={field.error ? `${field.id}-error` : undefined}
              disabled={field.disabled}
            />
            {field.type === 'password' && (
              <button
                type="button"
                className="auth-form__toggle-pw"
                onClick={() =>
                  setShowPassword((prev) => ({ ...prev, [field.id]: !prev[field.id] }))
                }
                aria-label={showPassword[field.id] ? 'Hide password' : 'Show password'}
                tabIndex={-1}
              >
                {showPassword[field.id] ? 'Hide' : 'Show'}
              </button>
            )}
          </div>
          {field.type === 'email' && emailSuggestion && (
            <p className="auth-form__hint">
              Did you mean{' '}
              <button
                type="button"
                className="auth-form__hint-link"
                onClick={() => applySuggestion(field)}
              >
                {emailSuggestion}
              </button>
              ?
            </p>
          )}
          {field.error && (
            <p className="auth-form__field-error" id={`${field.id}-error`} role="alert">
              {field.error}
            </p>
          )}
        </div>
      ))}

      {error && (
        <p className="auth-form__error" role="alert">
          {error}
        </p>
      )}

      {status && (
        <p
          className={`auth-form__status auth-form__status--${status.type}`}
          role={status.type === 'error' ? 'alert' : 'status'}
        >
          {status.message}
        </p>
      )}

      {children}

      <button type="submit" className="auth-form__submit" disabled={loading || fields.some((f) => f.disabled)}>
        {loading || fields.some((f) => f.disabled) ? loadingLabel : submitLabel}
      </button>
    </form>
  );
}

export default AuthForm;
